import { dateFormat, parseDate } from '@mirai/locale';

import { VERBOSE_DATE_FORMAT } from '../Chat.constants';

export const getVerboseDate = (date = [], locale) =>
  (Array.isArray(date) ? date : [date])
    .map((date) => dateFormat(parseDate(date), { locale, ...VERBOSE_DATE_FORMAT }))
    .join(' — ');
